import { useQuery } from '@tanstack/react-query';
import { gitApi } from '../api/gitApi';

export function useGitBranches(serverId: string | null, externalRef: string | null) {
  return useQuery({
    queryKey: ['gitBranches', serverId, externalRef],
    queryFn: () => {
      if (!serverId || !externalRef) throw new Error('serverId + externalRef required');
      return gitApi.listBranches(serverId, externalRef);
    },
    enabled: Boolean(serverId && externalRef),
  });
}
